import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { makeStyles } from '@mui/styles';
import { saveAssessmentSettings } from 'requests/ScriptRequests';
import { appCtx } from 'components/appStore';
import { assessmentSettingsCtx } from 'pages/assessment/store';

import Content from './Content';
import SideBar from './SideBar';

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        position: 'relative',
        overflow: 'auto',
        minHeight: 400,
        width: '100%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            display: 'block'
        }
    }
}));

const AssessmentSettingsMain = observer(({ routes, setSaving, match, isSaving }) => {
    const classes = useStyles();
    const { scriptSlug } = match.params;
    const [isLoading] = useState(false);
    const { audition, setAudition, loadEditScript, loadSettings, settings, setSettings } = useContext(assessmentSettingsCtx);
    const { company, loggedUser: { roleType: userRoleType } } = useContext(appCtx);

    useEffect(() => {
        loadEditScript();
        loadSettings();
    }, []);

    const changeAssessmentSettings = (form, callback) => {
        setSaving(true);
        return saveAssessmentSettings(scriptSlug, form)
            .then((response) => {
                const { success, data } = response;
                if (success && data) {
                    setSettings(data);
                    setAudition({ ...audition, ...data });
                    if (callback) {
                        callback();
                    }
                }
                setSaving(false);
                return response;
            })
            .catch(() => {
                setSaving(false);
            });
    };

    const childProps = {
        isSaving,
        isLoading,
        changeAssessmentSettings,
        setSaving,
        audition,
        setAudition,
        settings,
        setSettings,
        loadEditScript,
        company,
        userRoleType
    };

    return (
        <div className={classes.wrapper}>
            <SideBar routes={routes} {...childProps} />
            <Content routes={routes} {...childProps} />
        </div>
    );
});

export default withRouter(AssessmentSettingsMain);
